import React from 'react';

import WriteUsCard from './WriteUsCard';
import OpeningHours from './OpeningHours';
import Phone from './Phone';

import './contact-cards-schedule.scss';

const ContactCardsSchedule = ({ data }) => {
  return (
    <div className="contact-card-component">
      <WriteUsCard card={data} />
      <OpeningHours />
      <Phone />
    </div>
  );
};

export default ContactCardsSchedule;
